<div class="h-full flex flex-col bg-white relative">
  <rk-stepper
    [customNextStep]="finishCreation"
    [customNextStepText]="'monetization.next-step' | translate"
    [nextStepIsDisabled]="(isCreationProcess$ | async) && nextStepIsDisabled"
  ></rk-stepper>
  <div class="h-full overflow-scroll">
    <div class="w-full flex flex-col items-center">
      <h1 class="w-full text-center text-4xl font-bold mb-4 mt-10">
        {{ 'monetization.title' | translate }}
      </h1>
      <p>{{ 'monetization.configure-later' | translate }}</p>
      <!-- prettier-ignore -->
      <div class="px-8">
        <rk-admob></rk-admob>
      </div>
    </div>
  </div>
  @if (isFinishingPublication$ | async) {
    <div
      class="absolute top-0 flex justify-center items-center w-full h-full backdrop-blur z-20"
    >
      <mat-progress-spinner
        mode="indeterminate"
        [strokeWidth]="7"
        [diameter]="100"
      ></mat-progress-spinner>
    </div>
  }
</div>
